// modules/Preloader/PreloaderLoadUI.js
// 预加载器加载UI模块

import LoadingHelper from '../LoadingHelper.js';

export default class PreloaderLoadUI {
    constructor(scene) {
        this.scene = scene;
        this.loadingUI = null;
    }
    
    /**
     * 创建加载UI
     */
    create() {
        // 创建改进的加载UI
        this.loadingUI = LoadingHelper.createLoadingUI(this.scene);
    }
    
    /**
     * 更新进度
     * @param {number} progress - 进度百分比 (0-100)
     * @param {string} status - 状态文本
     */
    updateProgress(progress, status) {
        LoadingHelper.updateProgress(this.loadingUI, progress, status);
    }
    
    /**
     * 显示提示
     * @param {string} tip - 提示文本
     */
    showTip(tip) {
        LoadingHelper.showTip(this.loadingUI, tip);
    }
    
    /**
     * 销毁加载UI
     */
    destroy() {
        if (this.loadingUI) {
            LoadingHelper.destroy(this.loadingUI);
            this.loadingUI = null;
        }
    }
}

